import { useEffect, useState } from "react";
import { isCurrentLink, userHasRole, userHasUnixRoles } from "../../../misc/utils";
import { useNavigate } from "react-router-dom";
import { HasRole } from "../../../components/HasRole";

export const MenuItem = ({
  item,
  selectedItem,
  setSelectedItem,
  isMenuOpen,
}) => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const expand = () => setExpanded(!expanded);
  const goTo = (link) => () => {
    navigate(link);
    setSelectedItem(link.slice(7, -1));
  };

  useEffect(() => {
    if (
      item.nested?.find((nested) => isCurrentLink(window.location, nested.link))
    ) {
      setExpanded(true);
    }
  }, []);

  if (item.nested?.length) {
    const hasAvailableTabs = item.nested.map(n => ({ nativeRoles: userHasRole(n.role), optionalUnixRoles: userHasUnixRoles(n.optionalUnixRoles || []) })).some(obj => obj.nativeRoles || obj.optionalUnixRoles)
    if (!hasAvailableTabs) {
      return null
    }
  }

  return (
    <div className="flex flex-col w-full mt-6">
      <div className="h-6">
        {isMenuOpen && (
          <>
            <div
              className={`flex flex-row items-center justify-between cursor-pointer w-full`}
              onClick={expand}
            >
              <div className="flex flex-row items-center">
                <p className={`text-[13px] font-medium text-[#AFB7CA]`}>
                  {item.title}
                </p>
              </div>
            </div>
            <div className="bg-[#F0F3FA] h-[1px] w-full mt-3"></div>
          </>
        )}
      </div>

      <div className="flex flex-col  mt-3">
        {item.nested.map((nested, id) => {
          // const isLinkCurrent = isCurrentLink(window.location, nested.link);
          const Icon = nested.icon;
          return (
            <HasRole roles={[nested.role]} optionalUnixRoles={nested.optionalUnixRoles || []}>
              <div
                className={`flex flex-row items-center cursor-pointer px-2 py-3 rounded-lg ${nested.key === selectedItem ? "bg-[#F0F3FA]" : ""
                  }`}
                onClick={goTo(nested.link)}
                key={id}
              >
                {nested.icon && (
                  <div className={`w-6 h-6 text-[${nested.key === selectedItem ? "#0068FF" : "#AFB7CA"}]`}>
                    <Icon
                      color={nested.key === selectedItem ? "#0068FF" : "#AFB7CA"}
                    />
                  </div>
                )}

                {isMenuOpen && (
                  <p
                    className={`text-[15px] font-medium ml-3 ${nested.key === selectedItem
                      ? "text-[#0068FF]"
                      : "text-[#5F6B88]"
                      }`}
                  >
                    {nested.title}
                  </p>
                )}
              </div>
            </HasRole>
          );
        })}
      </div>
    </div>
  );
};
